import { Form } from "../form/form.model";
import { Deserializable } from "../models/deserializable.model";

export class Campaign implements Deserializable {
  _id:string = '';
  name:string = '';
  description:string = '';
  amount:number;
  goal:number = null;
  cpl:number = null;
  author:string = '';
  client:string = '';
  startDate:any = '';
  endDate:any = '';
  forms:Form[] = [];

  deserialize(input: any) {
    Object.assign(this, input);
    return this;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/campaign/campaign.model.ts